import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { GLOBAL_CONFIGURATION } from "./constants";

const resources = {
  en: {
    translation: {
      "Velg stasjon": "Select location",
      "Bestill fra meny": "Order from out menu",
      "Kontakt oss": "Contact us",
      Åpningstider: "Opening hours",
      Bestillinger: "Orders",
      "Opptjent bonus": "Earned bonus",
      "Din profil": "Your profile",
      "Stasjonens åpningstider": "Opening hours",
      "Våre stasjoner": "Our locations",
      "Bestill fra vår meny": "Order from our menu",
      "Se vår meny": "See our menu",
      "{{title}} kan dessverre ikke ta i mot bestillinger akkurat nå, du kan fortsatt se vår meny":
        "{{title}} cannot accept orders right now. You can still browse through our menu.",
      "Veibeskrivelse og åpningstid": "Directions and opening hours",
      "Finn produkter": "Find products",
      "Din bestilling": "Your order",
      Kvittering: "Receipt",
      Salgsbetingelser: "Terms of sale",
      "Om bonusprogrammet": "About the bonus program",
      "Slett din profil": "Delete your profile",
      "Handle mer": "Shop more",
      "Endre bestilling": "Change your order",
      "Inkl. mva": "Incl. VAT",
      Endre: "Change",
      Pris: "Price",
      Antall: "Qty",
      "Ta med": "Take-out",
      "Spis inne": "Eat in store",
      "Ta\u00A0med": "Take-out",
      "Spis\u00A0inne": "Eat\u00A0in",
      "Legg\u00A0til": "Add",
      Produkt: "Product",
      "Gå til kassen": "Proceed to checkout",
      "Legg til kommentar": "Add a comment",
      Kommentar: "Comment",
      "Kommentar til bestillingen": "Comments to the order",
      "Tilpass din bestilling": "Customize your order",
      "Din handlekurv er tom": "Your shopping cart is empty",
      "Gå til meny": "Go to meny",
      "Mobilnummer (8 siffer)": "Mobile number (8 digits)",
      Passord: "Password",
      "Husk med på denne enheten": "Remember me on  this device",
      "Glemt passord?": "Forgot password?",
      "Send nytt passord": "Send new password",
      "Har du ikke konto? Opprett nå!": "No account? Create one now!",
      "Feil brukernavn eller passord": "Incorrect username or password",
      produkt: "product",
      produkter: "products",
      "Har du noen kommentarer til bestillingen din?":
        "Do you have any comments to your order?",
      "Nytt passord ble sendt på SMS.": "New password was sent by SMS.",
      "Kunne ikke sende nytt passord. Prøv igjen senere":
        "Failed to send a new password. Try again later",

      // Menyvelgeren navigation
      "Tilbake til oversikt": "Back to overview",
      "Tilbake til meny": "Back to the meny",

      // From my pages
      "Din bonussaldo": "Your bonus balance",
      "Din saldo pr. {{date}}:": "Your saldo pr. {{date}}:",
      "Din bonus": "From the bonus",
      "Dine bestillinger": "Your orders",
      "Last inn flere": "Load more",
      Bestillingsnummer: "Order number",
      Dato: "Date",
      Navn: "Name",
      Sum: "Amount",
      "Vis bestilling": "Show order",
      "Navn er påkrevd": "Name is required",
      Mobilnummer: "Mobile phone number",
      "Fødselsdato (dd.mm.yyyy)": "Date of birth (dd.mm.yyyy)",
      Favorittstasjon: "Favorite store",
      Ingen: "None",
      "Send meg tilbud på SMS": "Send me offers on SMS",
      "Lagre profil": "Save profile",
      "Slett min profil": "Delete my profile",
      Profil: "Profile",
      "Bonussaldo og transaksjoner": "Balance and transactions",
      Ordrehistorikk: "Order history",
      Favoritter: "Favorites",
      "Ønsker du å slette din profil permanent? Her kan du slette alle data vi har lagret om deg":
        "Do you want to delete your profile permanently? Here you can delete all the data we have stored about you",
      "Vi vil oppbevare en kopi av dine data i 30 dager. Etter {{date}} vil alle dine data være borte. Du kan ikke bruke din profil i denne perioden.":
        "We will store a copy of your data for 30 days. After {{date}}, all your data will be gone. You cannot use your profile during this period.",
      "Slett min profil og bonus permanent":
        "Delete my profile and bonus permanent",
      "Vil du slette din profil permanent?":
        "Do you want to delete your profile permanently?",
      "Alle dine data, inkludert bonussaldo, vil bli slettet.":
        "All your data, including bonus balance, will be deleted.",
      "Nei, ta meg tilbake": "No, take me back",
      "Ja, slett min profil!": "Yes, delete my profile!",

      // Checkout
      "Litt om deg": "A bit about you",
      "Opprett konto": "Create account",
      "Har du allerede konto?": "Already have account?",
      "Logg inn": "Sign in",
      "Produktet er midlertidig utilgjengelig":
        "The product is temporarily unavailable",
      "Legg til i handlekurv": "Add to cart",
      "Mobilnummer er påkrevd": "Mobile number is required",
      "Mobilnummer kan kun bestå av 8 siffer":
        "Mobile number can only consist of 8 digits",
      "Lag en konto og start opptjening av bonus":
        "Create an account and start earning bonus",
      "Når skal bestillingen hentes?": "When will the order be picked up?",
      "Så snart som mulig.": "As soon as possible.",
      "Estimert leveringstid: {{deliveryTime}}":
        "Estimated delivery time: {{deliveryTime}}",
      "Velg tidspunkt": "Select time slot",
      "[i dag], DD.MMM": "[today], DD.MMM",
      "[i morgen], DD.MMM": "[tomorrow], DD.MMM",
      "Spis inne eller ta med?": "Eat inside or take-out?",
      "Hent og ta med": "Pick-up as take-out",
      "Bruk bonus?": "Use bonus?",
      "Du kan dessverre ikke bruke av din bonus for å redusere prisen på denne bestillingen.":
        "Unfortunately, you cannot use your bonus to reduce the price of this order.",
      "Velg betalingsmåte": "Choose payment method",
      "Å betale": "To pay (NOK)",
      "Bekreft bestilling": "Confirm order",
      "Du må logge inn eller opprette konto før du kan sende bestillingen":
        "You must log in or create an account before you can send your order",
      "Er du sikker?": "Are you sure?",
      "Er du sikker på at du vil fjerne produktet fra handlekurven?":
        "Are you sure you want to remove the product from the shopping cart?",
      "Nei, behold produktet": "No, keep the product",
      "Ja, slett fra handlekurven": "Yes, delete from the shopping cart",
      "Produktet ble lagt til i handlekurven.":
        "The product was added to the cart.",
      "Gå videre til betaling": "Proceed to payment",
      "Du kan bruke av din bonus for å redusere prisen på bestillingen.":
        "You can use your bonus to reduce the price of the order.",
      "På denne bestillingen kan du redusere prisen med <b>kr. {{amount}}</b> ved bruk av bonus.":
        "On this order you can reduce the price by <b> NOK {{amount}}</b> by using your bonus.",
      "Det gjenstår da <b>kr. {{amount}}</b> å betale.":
        "After bonus is subtracted, <b> NOK {{amount}} </b> is left to pay.",
      "Jeg ønsker å bruke kr. {{amount}} bonus nå":
        "I want to spend NOK {{amount}} in bonus now",
      "Hent på stasjon": "Pick up at the store",
      "Leveres til": "Delivery",
      "Levering på dør": "Delivery",
      "Rom nummer (Klingenberg Hotell)": "Room number at Hotel Klingenberg",
      "Midlertidig utsolgt": "Temporarily unavailable",
      "Produktet er midlertidig utsolgt. Velg gjerne noe annet fra menyen eller prøv igjen senere.":
        "The product is temporarily unavailable. Please feel free to choose something else from the menu or try again later.",
      "OK, tilbake til meny": "OK, back to menu",

      // Order errors
      "Det oppsto dessverre en feil ved behandling av din bestilling. Prøv igjen senere.":
        "Unfortunately, there was an error processing your order.Try again later.",
      "Ingen registrerte produkter på din bestilling":
        "No recorded products on your order",
      "Stasjonen er dessverre stengt.": "Unfortunately, the store is closed.",
      "Du må logge inn før du kan sende inn en bestilling":
        "You must log in before you can submit an order",
      "Du har ikke nok bonus på kontoen til å kunne redusere beløpet":
        "You don't have enough bonus on the account to be able to reduce the amount",
      "Det oppsto en ukjent feil ved behandling av din bestilling.":
        "An unknown error occurred when processing your order.",
      "Kan ikke behandle din bestilling": "Unable to process your order",
      "Sjekk alle feltene og korriger feilene":
        "Validate all the fields, and correct the errors",

      // Order confirmation
      Hentekode: "Pick-up code",
      MVA: "VAT",
      "Resterende å betale": "Remaining to pay",
      "Bestilling kansellert": "Order canceled",
      "Bestilling plassert": "Order placed",
      "Venter betaling": "Waiting Payment",
      "Mottatt på stasjon": "Received at store",
      "Bestillingen forberedes": "The order is being prepared",
      "Klar for henting!": "Ready for pickup!",
      "Ferdig!": "Completed!",
      Hentetidspunkt: "Pick-up time",
      "Hentetidspunkt er utsatt": "Pick-up time is delayed",
      "Snarest mulig": "As soon as possible",
      "Feil med betaling": "An error occurred with processing payment",
      "Din bestilling er ikke sendt til stasjonen.":
        "Your order is not sent to the store.",
      "Velg et alternativ nedenfor for å fortsette.":
        "Select an option below to continue.",
      "Avbryt bestilling": "Cancel order",
      "Se alle dine ordre": "View all your order",
      "Ordren du ser etter ble ikke funnet!":
        "The order you are looking for was not found!",
      "Beklager, ordren du ser etter ble ikke funnet.":
        "Sorry the order you are looking for was not found.",

      // Station closed
      "Stasjonen kan dessvere ikke ta i mot bestillinger akkurat nå.":
        "The store can not receive orders right now.",
      "Av kapasitetshensyn kan vi kun ta i mot digitale bestillinger i tidsrommene nedenfor.":
        "For capacity reasons, we can only accept digital orders in the periods below.",
      "Kom gjerne innom stasjonen i våre åpningstider":
        "Feel free to come to the store during our opening hours",

      "Ta gjerne en titt i menyen vår nedenfor":
        "Feel free to take a look at our menu below",
      "Bestillinger kan gjøres i stasjonens åpningstid":
        "Orders can be made during the store's opening hours",

      // Contact us
      "Juridisk navn": "Legal entity",
      "Org. nr.": "Organization number",
      "Tlf.": "Phone",
      "E-post": "E-mail",

      // Days
      Mandag: "Monday",
      Tirsdag: "Tuesday",
      Onsdag: "Wednesday",
      Torsdag: "Thursday",
      Fredag: "Friday",
      Lørdag: "Saturday",
      Søndag: "Sunday",
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: GLOBAL_CONFIGURATION.language ?? "nb",
  interpolation: { escapeValue: false },
});

export default i18n;
